import request from "@/axios.js";
import utilsMixin from "@/mixins/utilsMixin";
import store from "./store";

const actions = {
	// /////////////////////////////////////////////
	// COMPONENTS
	// /////////////////////////////////////////////

	// Vertical NavMenu
	updateVerticalNavMenuWidth({commit}, width) {
		commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
	},
	updateWindowHeigth({commit}, height) {
		commit("UPDATE_WINDOW_HEIGHT", height);
	},
	updateFilterCardHeight({commit}, height) {
		commit("UPDATE_FILTER_CARD_HEIGHT", height);
	},
	updateRelanceFilter({commit}, val) {
		commit("UPDATE_RELANCE_FILTER", val);
	},
	updateNoteCommercial({commit}, val) {
		commit("UPDATE_NOTE_COMMERCIAL", val);
	},
	updateHorizentalNavBarHeight({commit}, height) {
		commit("UPDATE_HORIZENTAL_NAVBAR_HEIGHT", height);
	},
	updateTableHeight({commit}, height) {
		commit("UPDATE_TABLE_HEIGHT", height);
	},
	updateFilterDown({commit}, height) {
		commit("UPDATE_FILTER_DOWN", height);
	},

	// VxAutoSuggest
	updateStarredPage({commit}, payload) {
		commit("UPDATE_STARRED_PAGE", payload);
	},

	// The Navbar
	arrangeStarredPagesLimited({commit}, list) {
		commit("ARRANGE_STARRED_PAGES_LIMITED", list);
	},
	arrangeStarredPagesMore({commit}, list) {
		commit("ARRANGE_STARRED_PAGES_MORE", list);
	},

	// /////////////////////////////////////////////
	// UI
	// /////////////////////////////////////////////

	toggleContentOverlay({commit}) {
		commit("TOGGLE_CONTENT_OVERLAY");
	},
	updateTheme({commit}, val) {
		commit("UPDATE_THEME", val);
	},

	// /////////////////////////////////////////////
	// User/Account
	// /////////////////////////////////////////////

	updateUserInfo({commit}, payload) {
		commit("UPDATE_USER_INFO", payload);
	},
	updateUserRole({dispatch}, payload) {
		// Change client side
		//console.log(payload);
		payload.aclChangeRole(payload.userRole);

		// Make API call to server for changing role

		// Change userInfo in localStorage and store
		dispatch("updateUserInfo", {userRole: payload.userRole});
	},
	//DELETE user commade
	deleteUserCommade({commit}, data) {
		commit("DELETE_USER_COMMANDES", data);
	},
	setSelectedSociety({commit}, payload) {
		commit("SET_SELECTED_SOCIETY", payload);
	},
	setStatDateFilter({commit}, payload) {
		commit("SET_STAT_DATE_FILTER", payload);
	},
	//setting is edit commade btn
	setEditUserCommandeBtn({commit}, data){
		commit("SET_EDIT_COMMANDES_BTN", data);
	},

	// SOCIETY
	getAllSocieties: ({commit}) => {
		request
			.get("society/all")
			.then(response => commit("SET_SOCIETIES", response.data.sort((a, b) => {
				return (a.name).localeCompare(b.name); //using String.prototype.localCompare()
			})));
	},

	getAllSocietiesTags: ({commit}) => {
		request
			.get("tags/society/all")
			.then(response => commit("SET_SOCIETIES_TAGS", response.data));
	},
	getRedacLang: ({commit}) => {
		request
			.get("mission/get_redac_lang")
			.then(response => commit("SET_REDAC_LANG", response.data));
	},
	getContentProduct: ({commit}) => {
		request.get("product/get_redac_product")
			.then(response => commit("SET_CONTENT_PRODUCT", response.data));
	},

	getAllSocietiesWithAnalyticsId: ({commit}) => {
		request
			.get("society/all/analytics")
			.then(response => commit("SET_SOCIETIES", response.data));
	},

	getAllSocietiesIdAndName: ({commit}) => {
		request
			.get("society/all")
			.then(response => commit("SET_SOCIETIES", response.data.sort((a, b) => {
				return (a.name).localeCompare(b.name); //using String.prototype.localCompare()
			})));
	},
	getAllFlexibleMissions: ({commit}) => {
		request
			.get("mission/getAllFlexibleMissionsNotif")
			.then(response => {
				commit("SET_FLEXIBLE_MISSIONS", response.data);
				return response.data;
			}).catch(err => {
				return err;
				//console.log(err);
			});
	},

	setPreviousSociety: ({commit}, val) => commit("SET_PREVIOUS_SOCIETY", val),
	//set usercommade
	setAllUserCommandes: ({commit}, data) => {
		commit("SET_COMMANDES", data.allOrders);
	},

	// /////////////////////
	// Contracts
	// /////////////////////
	getAllContracts: ({commit}) => {
		request
			.get("contract/all")
			.then(response => {
				/*
				 * for(let contract of response.data){
				 * 	request
				 * 		.get("contract/getrankwell/" + contract.id)
				 * 		.then(res => {
				 * 			contract.account_managers = [];
				 * 			for(let collaborator of res.data){
				 * 				if(collaborator.type == 0){
				 * 					contract.commercial_id = collaborator.users_id;
				 * 				}
				 * 				else{
				 * 					contract.account_managers.push(collaborator.users_id.toString());
				 * 				}
				 * 			}
				 * 		});
				 * }
				 */
				commit("SET_CONTRACTS", response.data);
			});
	},

	getAllContractsUsers: ({commit}) => {
		request
			.get("contract/getallrankwell")
			.then(response => {
				commit("SET_CONTRACTS_USERS", response.data);
			});
	},

	getAllContractsWithContractsUsers: ({commit}) => {
		request
			.get("contract/allccu")
			.then(response => {
				commit("SET_CONTRACTS_CONTRACTS_USERS", response.data);
			});
	},

	getAllContractsDocumentsTypes: ({commit}) => {
		request
			.get("contracts_documents/list/doctype/all")
			.then(response => {
				commit("SET_CONTRACTS_DOCUMENTS_TYPES", response.data);
			});
	},

	getAllCountries: ({commit}) => { // Get providers with service ids
		request
			.get("countries/all")
			.then(response => {
				commit("SET_COUNTRIES", response.data);
			});
	},

	// /////////////////////
	// Notifications
	// /////////////////////
	getAllNotifications: ({commit}) => {
		request
			.get("notifications/commercial/all")
			.then(response => {
				commit("SET_NOTIFICATIONS", response.data);
			});
	},

	getAllNotificationsTypes: ({commit}) => {
		request
			.get("notifications/type/all")
			.then(response => {
				commit("SET_NOTIFICATIONS_TYPES", response.data);
			});
	},

	// /////////////////////
	// Providers
	// /////////////////////
	getAllProviders: ({commit}) => { // Get providers with service ids
		request
			.get("providers/allws")
			.then(response => {

				commit("SET_PROVIDERS", response.data.sort((a, b) => {
					return (a.society).localeCompare(b.society); //using String.prototype.localCompare()
				}));
			});
	},

	getAllProvidersTags: ({commit}) => {
		request
			.get("tags/provider/all")
			.then(response => commit("SET_PROVIDERS_TAGS", response.data));
	},

	// /////////////////////
	// Services
	// /////////////////////
	getAllServices: ({commit}) => {
		request
			.get("service/all")
			.then(response => {
				commit("SET_SERVICES", response.data);
			});
	},

	// /////////////////////
	// Contacts
	// /////////////////////
	getAllContacts: ({commit}) => {
		request
			.get("users/all/contact")
			.then(response => commit("SET_CONTACTS", response.data));
	},

	// /////////////////////
	// Collaborators
	// /////////////////////
	getAllCollaborators: ({commit}) => {
		request
			.get("users/all/rankwell")
			.then(response => commit("SET_COLLABORATORS", response.data));
	},

	// /////////////////////
	// Collaborators Avatar
	// /////////////////////
	getAllCollaboratorsAvatar: ({commit}) => {
		request
			.get("users/all/rankwell/avatar")
			.then(response => commit("SET_COLLABORATORS_AVATAR", response.data))
			.catch(err => {
				//console.log(err);
			});

	},

	// /////////////////////
	// Products
	// /////////////////////
	getAllProducts: ({commit}) => {
		request
			.get("product/all")
			.then(response => {
				//console.log(response);
				commit("SET_PRODUCTS", response.data);
			});
	},

	getAllProductsCategories: ({commit}) => {
		request
			.get("product/category/all")
			.then(response => {
				//console.log(response);
				commit("SET_PRODUCTS_CATEGORIES", response.data);
			});
	},
	getPersonalNotificationList: ({commit}, user_id) => {
		request.get(`personal_notification/get/${user_id}`).then(response => {
			//console.log("notificationList , ", response);
			commit("SET_PERSONAL_NOTIFICATION", response.data);
		});
	},
	setNewCountPersonalNotification: ({commit}, user_id) => {
		request.post(`personal_notification/update/is_viewed/${user_id}`)
			.then(response => {
				commit("SET_PERSONAL_NOTIFICATION", response.data);
			});
	},


	getAllProductsSubCategories: ({commit}) => {
		request
			.get("product/subcategory/all")
			.then(response => {
				//console.log(response);
				commit("SET_PRODUCTS_SUB_CATEGORIES", response.data);
			});
	},

	// /////////////////////
	// Purchases
	// /////////////////////
	getAllPurchases: ({commit}) => {
		request
			.get("purchase/all")
			.then(response => commit("SET_PURCHASES", response.data));
	},
	getAllPurchasesWithRecurring: ({commit}) => {
		request
			.get("purchase/allrc")
			.then(response => {
				commit("SET_PURCHASES", response.data);
			});
	},
	getAllNetlinkThemaList: ({commit}) => {
		request.get("netlink/thema/all")
			.then(response => {
				commit("SET_NETLINK_THEMAS", response.data);
			});
	},
	getAllNetlinkIntl: ({commit}) => {
		request.get("netlink/netlinkIntl/all")
			.then(response => {
				commit("SET_NETLINK_INTL", response.data);
			});
	},

	// /////////////////////
	// Prospects Searches
	// /////////////////////
	getAllProspectsSearches: ({commit}) => {
		request
			.get("ps/all")
			.then(response => {
				//console.log(response);
				commit("SET_PROSPECTS_SEARCHES", response.data);
			});
	},

	getAllProspectsSearchesFull: ({commit}) => {
		request
			.get("ps/allfull")
			.then(response => {
				/*
				 * //console.log(response)
				 * let parsedResponse = []
				 * for(let row of response.data){
				 *   let parsedRow = row
				 *   parsedRow.prospect_list = parsedRow.prospect_list
				 *   parsedResponse.push(parsedRow)
				 * }
				 * "[{id:\"14\", url:\"https://www.temple-nobleart.com/\", domain_authority:\"33\", referring_domains:\"44\", referring_links:\"243\"},{id:\"15\", url:\"https://apollosportingclub.com/\", domain_authority:\"35\", referring_domains:\"29\", referring_links:\"375\"}]"
				 */
				commit("SET_PROSPECTS_SEARCHES", response.data);
			});
	},

	getProspectsProjects: ({commit}, payload) => {
		request
			.get("prospect/getProjects/" + payload)
			.then(response => {
				/*
				 * //console.log(response)
				 * let parsedResponse = []
				 * for(let row of response.data){
				 *   let parsedRow = row
				 *   parsedRow.prospect_list = parsedRow.prospect_list
				 *   parsedResponse.push(parsedRow)
				 * }
				 * "[{id:\"14\", url:\"https://www.temple-nobleart.com/\", domain_authority:\"33\", referring_domains:\"44\", referring_links:\"243\"},{id:\"15\", url:\"https://apollosportingclub.com/\", domain_authority:\"35\", referring_domains:\"29\", referring_links:\"375\"}]"
				 */
				commit("SET_PROSPECTS_PROJECTS", response.data);
			});
	},
	setNewProspects: ({commit}, payload) => {
		commit("SET_NEW_PROSPECTS", payload);
	},
	setOldProspects: ({commit}, payload) => {
		commit("SET_OLD_PROSPECTS", payload);
	},
	getAllProspectsSearchesFullId: ({commit}, payload) => {
		request
			.get("ps/allfullid/" + payload)
			.then(response => {
				/*
				 * //console.log(response)
				 * let parsedResponse = []
				 * for(let row of response.data){
				 *   let parsedRow = row
				 *   parsedRow.prospect_list = parsedRow.prospect_list
				 *   parsedResponse.push(parsedRow)
				 * }
				 * "[{id:\"14\", url:\"https://www.temple-nobleart.com/\", domain_authority:\"33\", referring_domains:\"44\", referring_links:\"243\"},{id:\"15\", url:\"https://apollosportingclub.com/\", domain_authority:\"35\", referring_domains:\"29\", referring_links:\"375\"}]"
				 */
				commit("SET_PROSPECTS_SEARCHES", response.data);
			});
	},

	// /////////////////////
	// Tasks
	// /////////////////////
	getAllTasks: ({commit}) => {
		request
			.get("task/all")
			.then(response => commit("SET_TASKS", response.data));
	},
	getTaskByContractId: ({commit}, contract_id) => {
		request
			.get("task/getByContractId/"+contract_id)
			.then(response => commit("SET_CONTRACT_TASKS", response.data));
	},

	getAllTerms: ({commit}) => {
		request
			.get("qb/invoices/term/all")
			.then(response => commit("SET_TERMS", response.data));
	},

	// /////////////////////
	// TVA
	// /////////////////////
	getAllTvaIds: ({commit}) => {
		request
			.get("qb/invoices/tva/all")
			.then(response => commit("SET_TVA_IDS", response.data));
	},

	getAllDocumentTypes: ({commit}) => {
		request
			.get("shared_document/list/doctype/all")
			.then(response => commit("SET_DOC_TYPE", response.data))
			.catch(err => {
				//console.log(err);
			});
	},
	// /////////////////////
	// Missions
	// /////////////////////
	getAllMissions: ({commit}) => {
		request
			.get("mission/all")
			.then(response => commit("SET_MISSIONS", response.data));
	},
	getAllOrders: ({commit}) => {
		request.get("orders/all")
		.then((res) => {
			commit("SET_ALL_ORDERS", res.data);
		});
	},

	// /////////////////////
	// Netlink
	// /////////////////////
	getAllNetlink: async({commit}) => {
		request
			.get("netlink/all")
			.then(response => commit("SET_NETLINK", response.data));
	},

	getAllNetlinkTypes: ({commit}) => {
		request
			.get("netlink/type/all")
			.then(response => commit("SET_NETLINK_TYPES", response.data));
	},

	// /////////////////////
	// Dns
	// /////////////////////
	getAllDns: ({commit}) => {
		request
			.get("dns/all")
			.then(response => commit("SET_DNS", response.data));
	},

	// /////////////////////
	// Reports
	// /////////////////////
	getAllReports: ({commit}) => {
		request
			.get("report/all")
			.then(response => commit("SET_REPORTS", response.data));
	},

	// /////////////////////
	// Users
	// /////////////////////
	getAllUsers: ({commit}) => {
		request
			.get("users/all")
			.then(response => commit("SET_USERS", response.data))
			.catch(err => {
				//console.log(err);
			});
	},

	getAllUsersSocieties: ({commit}) => {
		request
			.get("usersSocieties/all")
			.then(response => commit("SET_USERS_SOCIETIES", response.data))
			.catch(err => {
				//console.log(err);
			});
	},

	getAllCustomers: ({commit}) => {
		request
			.get("qb/getCustomers")
			.then(response => commit("SET_CUSTOMERS", response.data))
			.catch(err => {
				//console.log(err);
			});
	},

	setRowNum: ({commit}, data) => {
		commit("SET_ROW_NUM", data);
	},

	toogleNewCommandePopup: ({commit}, data) => {
		commit("TOOGLE_NEW_COMMANDE_POP", data);
	},

	setFilterFields: ({commit}, payload) => {
		commit("SET_FILTER_FIELDS", payload);
	},
	setContractPopUp: ({commit}, payload) => {
		commit("TOGGLE_IS_CONTRACT_POPUP", payload);
	},
	setNotifPopUp: ({commit}, payload) => {
		commit("TOGGLE_IS_NOTIF_POPUP", payload);
	},
	runClickEvent: ({commit}) => {
		commit("TRRIGER_CLICK_EVENTS", store);
	},
	setGoogleAds: ({commit}, payload) => {
		commit("SET_GOOGLE_ADS", payload)
	},

	// Prospect
	setKeywordListByAi: ({commit}, payload) => {
		commit("SET_KEYWORD_LIST_BY_AI", payload);
	},
	// Keywords
	fetchKeywordCategories: ({commit}) => {
		request
			.get("society/keywordCategories")
			.then(response => commit("SET_KEYWORD_CATEGORIES", response.data.reverse()))
			.catch(err => {
				//console.log(err);
			});
	},
	
};

export default actions;
